// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-image-modal .modal-dialog {\n  max-width: 50vw;\n}\n\n.profile-image-modal .modal-content {\n  height: 80vh;\n}\n\n.profile-image-modal__body {\n  height: calc(80vh - 56px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-image-modal__body img {\n  max-height: 100%;\n  width: auto;\n}\n\n", ""]);
// Exports
module.exports = exports;
